import { moment } from 'src/common/types';

export enum ModelCompositionMethod {
  Weighted = 'Weighted',
  Fixed = 'Fixed'
}

export enum ModelCompositionType {
  AssetAllocation = 'AssetAllocation',
  Sector = 'Sector',
  TradingStrategies = 'TradingStrategies',
  Overlays = 'Overlays',
  SMA = 'SMA'
}

export enum MenuOptions {
  None = 'None',
  Import = 'Import',
  Export = 'Export',
}

export enum AssetClass {
  AustralianShares = 'Australian Shares',
  FixedIncome = 'Fixed Income',
  Cash = 'Cash',
}

export interface ModelCompositionParameters {
  selectedGroup: string;
}

export interface FetchModelCompositionCSVPayload {
  modelVersionId: number;
  isModelVersionActive: boolean;
}

export interface ComponentAllocations {
  assetClass: string;
  componentId: number;
  componentCode: string;
  componentName: string;
  componentType: string;
  status: string;
  statusDate: moment;
  type: string;
  units: number;
  unitPrice: number;
  value: number;
  weight: number;
}

export interface AssetAllocation {
  securityCode: string;
  targetAllocation: number;
}

export interface FixedAssetAllocation
  extends AssetAllocation {
    assetClass: string;
}

// eslint-disable-next-line
export interface WeightedAssetAllocation
  extends AssetAllocation { }

export interface ImportRequestPayload {
  file: File;
}

export interface SaveModelCompositionAssetAllocationType {
  code: string;
  targetAllocation: number;
}

export interface SaveFixedModelCompositionAssetAllocationType
  extends SaveModelCompositionAssetAllocationType {
    assetClass: string;
    targetAllocation: number;
  }

// eslint-disable-next-line
export interface SaveWeightedModelCompositionAssetAllocationType
  extends SaveModelCompositionAssetAllocationType { }

export interface SaveModelCompositionPayload {
  modelId: number;
  modelMethod: ModelCompositionMethod;
  modelType: ModelCompositionType;
  assetAllocations: SaveModelCompositionAssetAllocationType[];
}

export interface SaveModelCompositionResult {
  warnings: string[];
  errors: string[];
  information: string[];
}

export interface AllocationsImporterResponse {
  errors: string[];
  information: string[];
  warnings: string[];
}

export interface CompositionGroup {
  label: string;
  value: number;
  weight: number;
  componentAllocations: ComponentAllocations[];
}

export interface CompositionDetail {
  modelVersionId: number;
  name: string;
  method: string;
  type: string;
  groups: CompositionGroup[];
}

export interface ModelCompositionState {
  parameters: ModelCompositionParameters;
  compositionDetail: CompositionDetail | null;
  importErrors: string[];
  importWarnings: string[];
  importInformation: string[];
  modelUploadSuccess: boolean;
}

export interface FetchModelCompositionPayload {
  modelVersionId: number;
}

export interface SecuritySearchResults {
  pageNumber: number;
  pageSize: number;
  results: SecuritySearchResult[];
  totalNumberOfPages: number;
  totalNumberOfRecords: number;
}

export interface SecuritySearchResult {
  entityCoreId: number;
  securityCode: string;
  securityId: number;
  securityName: string;
}

export interface SecurityValidationResult {
  securities: Security[];
  errors: string[];
}

export interface Security {
  securityId: number;
  securityName: string;
  securityCode: string;
  currentUnitPriceTime: string;
  currentUnitPrice: number;
  securityType: string;
  marketCode: string;
  assetClass: string;
  assetClassId: number;
}
